export default function () {
  const moduleName = 'backToTop'
  Array.from(document.querySelectorAll('.js-back-to-top')).forEach((wrapper) => {
    if (wrapper.dataset[moduleName + 'Init'] === 'true') return
    wrapper.dataset[moduleName + 'Init'] = 'true'

    const settings = {
      showAfter: 440,
      duration: 300
    }

    let timeout

    showOrHideBtn()

    /**
     * Events-start
     */

    window.addEventListener('scroll', showOrHideBtn)

    wrapper.addEventListener('click', (event) => {
      event.preventDefault()

      document.body.scrollIt({
        duration: settings.duration,
        easing: 'easeInQuad'
      })
    })

    /**
     * Events-end
     */

    /**
    * Functions-start
    */

    function showOrHideBtn () {
      clearTimeout(timeout)

      timeout = setTimeout(() => {
        if ((document.documentElement.scrollTop || document.body.scrollTop) > settings.showAfter) {
          wrapper.classList.add('visible')
        } else {
          wrapper.classList.remove('visible')
        }
      }, 300)
    }

    /**
     * Functions-end
     */
  })

  Element.prototype.scrollIt = function (settings) {
    const destination = this
    const duration = settings && settings.duration ? settings.duration : 300
    const easing = settings && settings.easing ? settings.easing : 'linear'
    const callback = settings && settings.callback ? settings.callback : undefined

    const easings = {
      linear (t) {
        return t
      },

      easeInQuad (t) {
        return t * t
      },

      easeOutQuad (t) {
        return t * (2 - t)
      },

      easeInOutQuad (t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
      },

      easeInCubic (t) {
        return t * t * t
      },

      easeOutCubic (t) {
        return (--t) * t * t + 1
      },

      easeInOutCubic (t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
      },

      easeInQuart (t) {
        return t * t * t * t
      },

      easeOutQuart (t) {
        return 1 - (--t) * t * t * t
      },

      easeInOutQuart (t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t
      },

      easeInQuint (t) {
        return t * t * t * t * t
      },

      easeOutQuint (t) {
        return 1 + (--t) * t * t * t * t
      },

      easeInOutQuint (t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t
      }
    }

    const start = window.pageYOffset
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime()

    const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight)
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight
    const destinationOffset = typeof destination === 'number' ? destination : destination.getBoundingClientRect().top + (document.documentElement.scrollTop || document.body.scrollTop)
    const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset)

    if ('requestAnimationFrame' in window === false) {
      window.scroll(0, destinationOffsetToScroll)

      if (callback) {
        callback()
      }

      return
    }

    function scroll () {
      const now = 'now' in window.performance ? performance.now() : new Date().getTime()
      const time = Math.min(1, ((now - startTime) / duration))
      const timeFunction = easings[easing](time)

      window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start))

      if (window.pageYOffset === destinationOffsetToScroll) {
        if (callback) {
          callback()
        }

        return
      }

      requestAnimationFrame(scroll)
    }

    scroll()
  }
};
